import React, {useContext, useEffect} from 'react';
import {Link} from 'react-router-dom'
import {Loading} from '../../custom/LoadingComponent'

import Container from '@mui/material/Container';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box'
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { DataGrid } from '@mui/x-data-grid';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

import * as Security from '../../../utils/auth/Security';
import * as CustomStyles from '../../styles/CustomStyles';
import * as ReduxDataStatus from '../../../utils/constants/ReduxDataStatus';
import * as Formatter from '../../util/Formatter';
import BucketContext from '../../context/BucketContext';
import {getEmployerSelectData, getWorksiteSelectData} from '../../util/TypeConvertor';
import * as AFFragment from '../../custom/AFFragment';


function Employees(props) {
    console.log('___Employees___');
    const bucketContext = useContext(BucketContext);

    useEffect(() => {
        props.loadComponentData();
    }, []);

    const getEmployerName = (employerId) => {
        return props.employers.filter( (employer) => employer.id === employerId )
                        .map( (employer) => employer.generalSection.employerName );
    }

    const getWorksiteName = (workSiteId) => {
        return props.worksites.filter((worksite) => worksite.id === workSiteId)
                .map((worksite) => worksite.generalSection.name+ ', ' + worksite.generalSection.localitate);
    }

    const getSelectedOccupationsDesc = () => {
        var occuptionsDesc = '[';
        for(var i=0; i<selectedOccupations.length; i++) {
            occuptionsDesc += selectedOccupations[i].description;
            if(i < selectedOccupations.length-1) {
                occuptionsDesc += ', ';
            }
        }
        occuptionsDesc += ']';

        return occuptionsDesc;
    }

    const employerSelectData = getEmployerSelectData(props.employers);

    var eState;
    if(!!bucketContext.bucket?.employeeFilter?.employerId)
        eState = bucketContext.bucket.employeeFilter.employerId;
    else if(employerSelectData.length > 0)
        eState = employerSelectData[0].id;
    else
        eState = '';

    const [selectedEmployerId, setSelectedEmployerId] = React.useState( eState );
    const [selectedWorksiteId, setSelectedWorksiteId] = React.useState( !!bucketContext.bucket?.employeeFilter?.worksiteId ? bucketContext.bucket.employeeFilter.worksiteId : -1);
    const [expandedState, setExpandedState] = React.useState( !!bucketContext.bucket?.employeeFilter?.expanded ? bucketContext.bucket.employeeFilter.expanded : false );

    const [selectedOccupations, setSelectedOccupations] = React.useState( !!bucketContext.bucket?.employeeFilter?.occupations ? bucketContext.bucket.employeeFilter.occupations : []);
    const [selectedOccupationsCod, setSelectedOccupationsCod] = React.useState( !!bucketContext.bucket?.employeeFilter?.occupationsCod ? bucketContext.bucket.employeeFilter.occupationsCod : []);
    const [inputValue, setInputValue] = React.useState('');

    const worksiteSelectData = getWorksiteSelectData(selectedEmployerId, props.worksites, true);

    const handleEmployerChange = (employerId) => {
        setSelectedEmployerId(employerId);
        setSelectedWorksiteId(-1);
        bucketContext.setBucketValue({employeeFilter: {employerId: employerId, worksiteId: -1, occupations: [], occupationsCod:[], expanded: true}});
    }

    const handleWorksiteChange = (worksiteId) => {
        setSelectedWorksiteId(worksiteId);
        bucketContext.setBucketValue({employeeFilter: {employerId: selectedEmployerId, worksiteId: worksiteId, occupations: selectedOccupations, occupationsCod: selectedOccupationsCod, expanded: true}});
    }

    const handleOccupationChange = (occupations) => {
        const occupationsCod = occupations.map((occupation) => occupation.cod)
        setSelectedOccupations(occupations);
        setSelectedOccupationsCod(occupationsCod);
        bucketContext.setBucketValue({employeeFilter: {employerId: selectedEmployerId, worksiteId: selectedWorksiteId, occupations: occupations, occupationsCod: occupationsCod, expanded: true}});
    }

    const toggleAcordion = (newState) => {
        setExpandedState(newState);
        bucketContext.setBucketValue({employeeFilter: {...bucketContext.bucket.employeeFilter, expanded: newState}});
    };

    var filteredEmployees = [];
    if(selectedWorksiteId === -1) {
        filteredEmployees = 
            selectedOccupationsCod.length === 0 ?
                props.employees.employees.filter(employee => employee.employmentDetails.employerId === selectedEmployerId)
                    :
                props.employees.employees.filter(employee => (
                                                                employee.employmentDetails.employerId === selectedEmployerId && 
                                                                employee.employmentDetails.occupationCOR &&
                                                                selectedOccupationsCod.includes( employee.employmentDetails.occupationCOR )
                                                ))
    }
    else {
        filteredEmployees = 
            selectedOccupationsCod.length === 0 ?
                props.employees.employees.filter(employee => employee.employmentDetails.workSiteId === selectedWorksiteId)
                    :
                props.employees.employees.filter(employee => (
                                                                employee.employmentDetails.workSiteId === selectedWorksiteId && 
                                                                employee.employmentDetails.occupationCOR &&
                                                                selectedOccupationsCod.includes( employee.employmentDetails.occupationCOR )
                                                ))
    }

    // const filteredEmployees = selectedWorksiteId === -1 ?
    //                         props.employees.employees.filter(employee => employee.employmentDetails.employerId === selectedEmployerId)
    //                             :
    //                         props.employees.employees.filter(employee => employee.employmentDetails.workSiteId === selectedWorksiteId);

    const selectedFilters = getEmployerName(selectedEmployerId) + 
                            (selectedWorksiteId !== -1 ? ' -> ' + getWorksiteName(selectedWorksiteId) : '') +
                            (selectedOccupations.length > 0 ? ' -> ' + getSelectedOccupationsDesc() : '');

    const columns = [
        {
            field: 'lastName',
            headerName: 'Nume',
            width: 150,
            valueGetter: (params) => params.row.generalSection.lastName,
            renderCell: (params) => {
                return (
                    <Link to={`/employees/${params.row.id}`}>
                        {params.row.generalSection.lastName}
                    </Link>
                );
            }
        },
        {
            field: 'firstName',
            headerName: 'Prenume',
            width: 150,
            valueGetter: (params) => params.row.generalSection.firstName
        },
        {
            field: 'nume-angajator',
            headerName: 'Angajator',
            width: 250,
            valueGetter: (params) => getEmployerName(params.row.employmentDetails.employerId)
        },
        {
            field: 'nume-punct-de-lucru',
            headerName: 'Punct de Lucru',
            width: 250,
            valueGetter: (params) => getWorksiteName(params.row.employmentDetails.workSiteId)
        },
        {
            field: 'cnp',
            headerName: 'CNP',
            width: 150,
            valueGetter: (params) => params.row.generalSection.cnp
        },
        {
            field: 'ocupatiaCOR',
            headerName: 'Ocupatia (COR)',
            width: 300,
            valueGetter: (params) => params.row.employmentDetails.occupationCORdescription
        },
        {
            field: 'updateDate',
            headerName: 'Data Modificare',
            width: 115,
            valueGetter: (params) => params.row.updateDate,
            renderCell: (params) => {
                return(Formatter.formatDatetoRO(params.row.updateDate));
            }            
        },
        {
            field: 'updateBy',
            headerName: 'Modificat De',
            width: 150,
            valueGetter: (params) => params.row.updateBy?.updateByFullName
        }
    ];

    if (props.dataStatus === ReduxDataStatus.LOADING) {
        return(
            <Container maxWidth="xl" >
                <Box px={{xs: 3, sm: 7}}>
                    <Loading />
                </Box>
            </Container>
        );
    }
    else if (props.employees.errMess) {
        return(
            <Container maxWidth="xl" >
                <Box px={{xs: 3, sm: 7}}>
                    <h4>{props.employees.errMess}</h4>
                </Box>
            </Container>
        );
    }
    else { 
        return(
            <Container maxWidth="xl" >
            <Box px={{xs: 3, sm: 7}}>

                <Stack spacing={1} sx={{marginBottom: 2}}>
                    <Box>
                        <Breadcrumbs aria-label="breadcrumb" sx={{ mt: 1, mb: 1 }}>
                            <Link to="/home">Acasa</Link>
                            <Typography color="text.primary">Angajati</Typography>
                        </Breadcrumbs>
                    </Box>

                    <Box>
                        <Box style={{display:"flex", marginBottom: 4}}>
                            <h3>Angajati</h3>
                            <Box sx={{ width:'100%'}} display="flex" justifyContent="flex-end" alignItems="flex-end">
                                <Link to={'/newemployee'}>
                                    <Button variant="outlined" sx={{ marginRight: 0.5, marginTop: 0.5 }} >Adauga Angajat</Button>
                                </Link>
                            </Box>
                        </Box>                
                    </Box>
                    <hr />

                    {Security.isSystemUser() &&
                        <Grid container spacing={2} sx={CustomStyles.gridStyles}>
                            {/*row*/}
                            <Grid item xs={4}>
                                <AFFragment.ClientContextSection clients={props.clients.clients}/>
                            </Grid>
                        </Grid>
                    }

                    <Accordion expanded={expandedState} >
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon onClick={() => toggleAcordion(!expandedState)}/>}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                        >
                            <Typography>Filtre: {selectedFilters}</Typography>
                        </AccordionSummary>
                        <AccordionDetails>

                        <Grid container spacing={2} sx={CustomStyles.gridStyles}>
                            {/*row*/}
                            <Grid item xs={4}>
                                <FormControl fullWidth size="small" margin="dense" variant="standard">
                                    <InputLabel id={'daAngajator-inputLabelId'}>Angajator</InputLabel>
                                    <Select
                                        labelId={'daAngajator-selectLabelId'}
                                        id={'daAngajator'}
                                        value={selectedEmployerId}
                                        onChange={(event) => handleEmployerChange(event.target.value) } 
                                        label={'daAngajator-label'}
                                    >
                                        {
                                            employerSelectData.map((data) => <MenuItem dense value={data.id} key={data.id}> {data.name} </MenuItem>)
                                        }
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={4}>
                                <FormControl fullWidth size="small" margin="dense" variant="standard">
                                    <InputLabel id={'daWorkSite-inputLabelId'}>Punct de Lucru</InputLabel>
                                    <Select
                                        labelId={'daWorkSite-selectLabelId'}
                                        id={'daWorkSite'}
                                        value={selectedWorksiteId}
                                        onChange={(event) => handleWorksiteChange(event.target.value)}
                                        label={'daWorkSite-label'}
                                    >
                                        {
                                            worksiteSelectData.map((data) => <MenuItem dense value={data.id} key={data.id}> {data.name} </MenuItem>)
                                        }
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={4}>
                            </Grid>

                            {/*row*/}
                            <Grid item xs={8}>
                            <Autocomplete
                                id="cor-code-autocomplete"
                                multiple
                                size="small"
                                options={props.corCodes}
                                getOptionLabel={(option) => option.cod + ' - ' + option.description}
                                value={selectedOccupations}
                                onChange={(event, newValue) => handleOccupationChange(newValue) }
                                // inputValue={inputValue}
                                // onInputChange={(event, newInputValue) => setInputValue(newInputValue) }
                                renderInput={(params) => (
                                    <TextField {...params} variant="standard" size="small" fullWidth margin="dense" label="Ocupatia (COR)" 
                                    />
                                )}
                            />
                            </Grid>
                            <Grid item xs={4}>
                            </Grid>

                        </Grid>

                        </AccordionDetails>
                    </Accordion>

                    <Box sx={{ height: 650, width: '100%', marginTop: 2, marginBottom: 2 }}>
                        {
                            props.employees.status === ReduxDataStatus.SUCCEEDED ?
                                <DataGrid
                                    rows={filteredEmployees}
                                    columns={columns}
                                    initialState={{
                                        sorting: { sortModel: [{ field: 'lastName', sort: 'asc' }] }
                                    }}
                                    pageSize={10}
                                    rowsPerPageOptions={[10]}
                                    checkboxSelection={false}
                                    disableSelectionOnClick
                                    experimentalFeatures={{ newEditingApi: true }}
                                />
                                :
                                <Loading />
                        }
                    </Box>
                </Stack>

            </Box>
            </Container>
        );
    }
}

export default Employees;